export default {
    fr:{

        // Expert / AO / Rechercher AO 15
        'Rechercher un appel d\'offre' :'Rechercher un appel d\'offre',
        'Catégorie' :'Catégorie',
        'Lieu' :'Lieu',
        'Filtrer' :'Filtrer',
        'Tous les appels d\'offres' : 'Tous les appels d\'offres',
        'Non précisé' :'Non précisé',
        'jouter aux favoris' :'jouter aux favoris',
        'Filtres' :'Filtres',
        // 'Intitulé de poste' :'Intitulé de poste',
        'Rechercher un poste' :'Rechercher un poste',
        'Référence' :'Référence',
        'Rechercher une référence' :'Rechercher une référence',
        'TJM' :'TJM',
        'Ajouter un TJM' :'Ajouter un TJM',
        'Type d\'intervention' :'Type d\'intervention',
        'Travail à distance/présentiel' :'Travail à distance/présentiel',
        'Durée de la mission' :'Durée de la mission',
        'Sélectionner une durée' :'Sélectionner une durée',
        'Entreprise' :'Entreprise',
        'Ajouter le nom d\'une entreprise' :'Ajouter le nom d\'une entreprise',
        'Date de début souhaitée' :'Date de début souhaitée',
        'Date de publication' :'Date de publication',
        'Sélectionner une date' :'Sélectionner une date',
        'Réinitialiser' :'Réinitialiser',
        'Rechercher' :'Rechercher',
        // 'Description' :'Description',
        'Contexte de la mission' :'Contexte de la mission',
        'Répondre à l\'offre' :'Répondre à l\'offre',
        'À répondre avant' :'À répondre avant',
        'Candidature à l\'appel d\'offre' :'Candidature à l\'appel d\'offre',
        'Taux journalier et Disponibilité' :'Taux journalier et Disponibilité',
        // 'Immédiate' :'Immédiate',
        'En une date' :'En une date',
        'Présentation et motivation (recommandé)' :'Présentation et motivation (recommandé)',
        'Argumentaire commercial' :'Argumentaire commercial',
        'Précisez pourquoi votre candidature est pertinente pour cet appel d\'offre.' :'Précisez pourquoi votre candidature est pertinente pour cet appel d\'offre.',
        'Valider la proposition' :'Valider la proposition',
        //Expert / AO / Mes RDV 17
        'Mes Rendez-vous' :'Mes Rendez-vous',
        // 'Rendez-vous à venir' :'Rendez-vous à venir',
        'Rendez-vous Passés' :'Rendez-vous Passés',
        'Aucun rendez vous pour le moment' :'Aucun rendez vous pour le moment',
        //Expert / AO / Mes Favoris 18
        // 'Mes favoris' :'Mes favoris',
        'Ajouter à la liste de mes favoris' :'Ajouter à la liste de mes favoris',
        'Supprimer de la liste de mes favoris' :'Supprimer de la liste de mes favoris',
        //Expert / AO / Mes Alertes 19
        // 'Mes alertes' :'Mes alertes',
        'Vous trouverez ici vos alertes de recherche' :'Vous trouverez ici vos alertes de recherche',
        'Vous pouvez définir votre alerte de recherche' :'Vous pouvez définir votre alerte de recherche',
        'Créer une alerte' :'Créer une alerte',
        // 'Intitulé de poste' :'Intitulé de poste',
        // 'Rechercher un poste' :'Rechercher un poste',
        'Localisation' :'Localisation',
        'Ajouter une localisation' :'Ajouter une localisation',
        'Mots clés' :'Mots clés',
        'Ajouter des compétences par exemple' :'Ajouter des compétences par exemple',
        'Répondre à l\'appel d\'offres':'Répondre à l\'appel d\'offres',
        'Candidature à l\'appel d\'offres':'Candidature à l\'appel d\'offres',
        'TJ souhaité percevoir':'TJ souhaité percevoir',
        'Disponibilité':'Disponibilité',
        '00/jour':'00/jour',
        'Expliquez en quoi votre candidature est pertinente pour répondre à cet appel d\'offres.':'Expliquez en quoi votre candidature est pertinente pour répondre à cet appel d\'offres.',
        'vous avez déjà postulé à cet appel d\'offres':'vous avez déjà postulé à cet appel d\'offres',

    },
    en:{
        //Expert / AO / Rechercher AO 15
        'Rechercher un appel d\'offre' :'Search for a job',
        'Catégorie' :'Category',
        'Lieu' :'Location',
        'Filtrer' :'Filter',
        'Tous les appels d\'offres' : 'All Jobs',
        'Non précisé' :'Not indicated',
        'A':'A',
        'jouter aux favoris' :'dd to favorites',
        'Filtres' :'Filters',
        // 'Intitulé de poste' :'Job title',
        'Rechercher un poste' :'Search for a job',
        'Référence' :'Reference',
        'Rechercher une référence' :'Search for a reference',
        'TJM' :'MRD',
        'Ajouter un TJM' :'Add a MDR',
        'Type d\'intervention' :'Work options',
        'Travail à distance/présentiel' :'on-site/off-site',
        'Durée de la mission' :'Duration of the assignment ',
        'Sélectionner une durée' :'Select a duration',
        'Entreprise' :'Company',
        'Ajouter le nom d\'une entreprise' :'Add a company name',
        'Date de début souhaitée' :'Desired start date',
        'Date de publication' :'Publication date',
        'Sélectionner une date' :'Select a date',
        'Réinitialiser' :'Reset',
        'Rechercher' :'Search',
        // 'Description' :'Description',
        'Contexte de la mission' :'Project scope',
        'Répondre à l\'offre' :'Apply for the job',
        'À répondre avant' :'Apply before',//#
        'Candidature à l\'appel d\'offre' :'Job application',
        'Taux journalier et Disponibilité' :'Daily Rate and Availability',
        // 'Immédiate' :'Immediate',
        'En une date' :'On a date',
        'Présentation et motivation (recommandé)' :'Presentation and motivation (recommended)',
        'Argumentaire commercial' :'Commercial argument',
        'Précisez pourquoi votre candidature est pertinente pour cet appel d\'offre.' :'State why your application is relevant for this job.',
        'Valider la proposition' :'Validate the proposal',
        //Expert / AO / Candidatures 16
        'Référence de l\'AO' :'Job reference',
        'Réf.AO' :'Job ref.',
        'Réf. AO' :'Job ref.',
        'Date de candid.' :'Application date',
        'Date de candidature' :'Application date',
        'Intitulé de l\'AO' :'Job title',
        'Statut candidature' :'Application status',
        'Date de début souhaité' :'Desired start date',
        'Date début souhaité' :'Desired start date',
        // 'Date de publication' :'Publication date',
        // 'Durée de la mission' :'Mission duration',
        'Durée du BDC' :'PO duration',
        'Budget' :'Budget',
        'TJ souhaité' :'DR desired',
        'Ville et pays' :'City & country',
        'Non lue' :'Not read',
        'Reçue' :'Received',
        'Intéressante' :'Interesting',
        'A interviewer' :'To interview',
        'Retenue' :'Selected',
        'Non retenue' :'Not selected',
        'BDC signé' :'PO signed',
        //Expert / AO / Mes RDV 17
        'Mes Rendez-vous' :'My appointments',
        // 'Rendez-vous à venir' :'Future  appointments',
        'Rendez-vous Passés' :'Past appointments',
        'Aucun rendez vous pour le moment' :'No appointment for the moment',
        //Expert / AO / Mes Favoris 18
        // 'Mes favoris' :'My favorites',
        'Ajouter à la liste de mes favoris' :'Add to the my favorite list',
        'Supprimer de la liste de mes favoris' :'Remove from  my favorite list',
        //Expert / AO / Mes Alertes 19
        // 'Mes alertes' :'My alerts',
        'Vous trouverez ici vos alertes de recherche' :'Here you will find your search alerts',
        'Vous pouvez définir votre alerte de recherche' :'You can define your search alert',
        'Créer une alerte' :'Create an alert',
        // 'Intitulé de poste' :'Job title',
        // 'Rechercher un poste' :'Search for a job',
        'Localisation' :'Location',
        'Ajouter une localisation' :'Add a location',
        'Mots clés' :'Key words',
        'Ajouter des compétences par exemple' :'Add skills for example',
        // 'Mes alertes' :'My alerts',
        // 'Supprimer cette entrée' :'Delete this entry',
        //Expert /Missions et BDC/ Ordres de mission 20
        'Réf.mission' :'Assignment ref.',
        'Réf. Mission' :'Assignment ref.',
        'Réf.Ordre de mission':'Work order ref.',
        'Statut document':'Document status',
        'Date début BDC':'PO start date',
        'Date fin BDC':'PO end date',
        'Durée BDC':'PO duration',
        'TJ HT':'DR excl.VAT',
        'Date d\'émission' :'Date of issue',
        'Intitulé de la mission' :'Job title',
        'Client' :'Client',
        'Statut' :'Status',
        'Début souhaité' :'Desired start',
        // 'Durée de la mission' :'Duration of role',
        // 'Durée du BDC' :'PO duration',
        'Responsable Opérationnel' :'Operational Manager',
        'Commercial' :'Commercial',
        'Ordre de mission à valider' :'Work order to be validated',
        // 'Contexte de la mission' :'Project scope',
        'Télécharger l\'ordre de mission' :'Download the work order',
        // 'Valider' :'Validate',
        'Ordre de mission' :'Work order',
        'Numéro de l\'ordre de mission' : 'Work order number',
        // 'Date de début souhaitée' : 'Requested start date',
        'Nombre de postes' :'Number of jobs',
        'Répondre à l\'appel d\'offres':'Respond to the call for tender',
        'Candidature à l\'appel d\'offres':'Tender application',
        'TJ souhaité percevoir':'Desired daily rate',
        'Disponibilité':'Availability',
        '00/jour':'00/day',
        'Expliquez en quoi votre candidature est pertinente pour répondre à cet appel d\'offres.':'Explain how your application is relevant to respond to this call for tender.',
        'vous avez déjà postulé à cet appel d\'offres':'You have already applied to this call for tender',

    }
};